import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  head: {
    display: "flex",
    alignItems: "center",
    padding: "12px 0px 6px",
  },
  title: {
    // flex: 1,
    margin: "0 10px",
    fontSize: 18,
    fontWeight: 700,
    color: "#2f2f2f",
  },
  link: {
    fontSize: 12,
    color: "#4fa3d5",
    textDecoration: "none",
  },
  body: {
    color: "#848484",
    padding: "0 0 16px 10px",
  },
  bodyTitle: {
    margin: 0,
  },
}));

export default useStyles;
